module.exports = __webpack_public_path__ + "static/media/icon_axis_default.9e217cc5.svg";